import { render, staticRenderFns } from "./detailsLeaderFree.vue?vue&type=template&id=803490a8&scoped=true&"
import script from "./detailsLeaderFree.vue?vue&type=script&lang=js&"
export * from "./detailsLeaderFree.vue?vue&type=script&lang=js&"
import style0 from "./detailsLeaderFree.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./detailsLeaderFree.vue?vue&type=style&index=1&id=803490a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "803490a8",
  null
  
)

component.options.__file = "detailsLeaderFree.vue"
export default component.exports